import { createRouter, createWebHistory } from "vue-router";
import Apps from "../views/Apps.vue";
import store from "../store";

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/auth/Login.vue"),
    meta: {
      title: `เข้าสู่ระบบ`,
      requiresGuest: true,
    },
  },
  {
    path: "/random",
    name: "Random",
    component: () => import("@/views/Random.vue"),
    meta: {
      title: `Random`,
    },
  },
  {
    path: "/it-random",
    name: "ItRandom",
    component: () => import("@/views/ItRandom.vue"),
    meta: {
      title: `ItRandom`,
    },
  },
  {
    path: "/",
    name: "home",
    component: Apps,
    redirect: "dashboard",
    meta: {
      requiresAuth: true,
      title: `หน้าหลัก`,
      roles: ["admin", "manager", "user"],
    },
    children: [
      {
        path: "/test",
        name: "Test",
        component: () => import("@/views/Test.vue"),
        meta: {
          title: `Test`,
        },
      },
      {
        path: "/create-over-time",
        name: "CreateOverTime",
        component: () => import("@/views/CreateOverTimePage.vue"),
        meta: {
          title: `สร้างใบเสริม`,
        },
      },
      {
        path: "/admin",
        name: "Admin",
        component: () => import("@/views/Admin.vue"),
        meta: {
          title: `ผู้ดูแลระบบ`,
        },
      },
      {
        path: "/work-group-table-type-note",
        name: "WorkGroupTableTypeNote",
        component: () => import("@/views/WorkGroupTableTypeNote.vue"),
        meta: {
          title: `หมายเหตุ`,
        },
      },
      {
        path: "/holiday",
        name: "Holiday",
        component: () => import("@/views/Holiday.vue"),
        meta: {
          title: `วันหยุด`,
        },
      },
      {
        path: "/user-group-by",
        name: "UserGroupBy",
        component: () => import("@/views/UserGroupBy.vue"),
        meta: {
          title: `เจ้าหน้าที่หน่วยงาน`,
        },
      },
      {
        path: "work-shift",
        name: "workshift",
        component: () => import("@/views/WorkShift.vue"),
        meta: {
          title: `ตารางเวร`,
        },
      },
      {
        path: "change-work-shift",
        name: "changeworkshift",
        component: () => import("@/views/ChangeWorkShift.vue"),
        meta: {
          title: `ขอเปลี่ยนเวร`,
        },
      },
      {
        path: "work-shift-type",
        name: "workshifttype",
        component: () => import("@/views/WorkShiftType.vue"),
        meta: {
          title: `ประเภทเวร`,
        },
      },
      {
        path: "table-type",
        name: "tabletype",
        component: () => import("@/views/TableType.vue"),
        meta: {
          title: `ประเภทตารางเวร`,
        },
      },
      {
        path: "request-stop",
        name: "requeststop",
        component: () => import("@/views/RequestStop.vue"),
        meta: {
          title: `ขอวันหยุด`,
        },
      },
      {
        path: "manage-work",
        name: "managework",
        component: () => import("@/views/ManageWork.vue"),
        meta: {
          title: `จัดการเวร`,
        },
      },
      {
        path: "rate",
        name: "rate",
        component: () => import("@/views/Rate.vue"),
        meta: {
          title: `ประเภทค่าตอบแทน`,
        },
      },
      {
        path: "work-group",
        name: "workgroup",
        component: () => import("@/views/WorkGroup.vue"),
        meta: {
          title: `กลุ่มงาน`,
        },
      },
      {
        path: "endorser",
        name: "endorser",
        component: () => import("@/views/Endorser.vue"),
        meta: {
          title: `ผู้ลงนามรับรอง`,
        },
      },
      {
        path: "user-group",
        name: "usergroup",
        component: () => import("@/views/UserGroup.vue"),
        meta: {
          title: `เจ้าหน้าที่`,
        },
      },
      {
        path: "",
        name: "dashboard",
        component: () => import("../views/Dashboard.vue"),
        meta: {
          title: `หนัาหลัก`,
        },
      },
      {
        path: "/profile",
        name: "profile",
        component: () => import("../views/Profile.vue"),
        meta: {
          title: `ข้อมูลส่วนตัว`,
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} | ${process.env.VUE_APP_NAME_EN}`;

  const isAuthenticated = store.getters.isAuthenticated;

  if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !isAuthenticated
  ) {
    next({ name: "login" });
  } else if (
    to.matched.some((record) => record.meta.requiresGuest) &&
    isAuthenticated
  ) {
    if (to.meta?.roles?.includes(store.state.role)) {
      next();
    } else {
      next({ name: "dashboard" });
    }
  } else {
    next();
  }
});

export default router;
